import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';

import Checkbox from '@/components/Checkbox';
import { FactsheetDetails } from '@/pages/Facthsheets/constants';
import ItemsTableRow from '@/pages/Facthsheets/FactsheetView/FactsheetWindow/FactsheetBody/Tabs/ItemsTab/ItemsTableRow';
import useItemsTab from '@/pages/Facthsheets/FactsheetView/FactsheetWindow/FactsheetBody/Tabs/ItemsTab/useItemsTab';

const ItemsTab = ({ factsheet }: { factsheet: FactsheetDetails }) => {
  const { handleAllItemsSelection, allItemsSelected } = useItemsTab(factsheet);
  return (
    <Box sx={{ width: '100%' }}>
      <Typography sx={{ fontWeight: 'bold' }}>
        Item(s) Available {factsheet.symbols?.length}
      </Typography>
      <TableContainer>
        <Table
          stickyHeader
          aria-label='factsheet items table'
          size='small'
        >
          <TableHead>
            <TableRow
              sx={theme => ({
                '& td, & th': {
                  pb: 1,
                  fontWeight: 'bold',
                  borderBottom: `0.5px solid ${theme.palette.text.primary}`,
                  backgroundColor: 'background.paper'
                }
              })}
            >
              <TableCell
                align='right'
                component='th'
                scope='row'
                sx={{ pl: 1, pr: 1, width: 24 }}
              >
                <Checkbox
                  checked={allItemsSelected}
                  sx={{ mb: '3px' }}
                  onChange={handleAllItemsSelection}
                />
              </TableCell>

              <TableCell>Code</TableCell>
              <TableCell>TimeRef</TableCell>
              <TableCell>PeriodType</TableCell>
              <TableCell>Period</TableCell>
              <TableCell>Alias</TableCell>
              <TableCell> TimeRef Detail</TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              '&  .markets-table-row:nth-of-type(even)': {
                backgroundColor: 'secondary.main'
              },
              '&  .markets-table-row:nth-of-type(even) + td': {
                backgroundColor: 'secondary.main'
              }
            }}
          >
            {factsheet.symbols.map((symbol, index) => (
              <ItemsTableRow
                key={factsheet.code + index}
                code={factsheet.code}
                symbol={symbol}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
export default ItemsTab;
